import { create } from 'zustand';
import { products as staticProducts, categories as staticCategories, Product, Category } from '../data/products';

interface ShippingSettings {
  shippingCost: number;
  freeShippingMin: number;
}

interface ProductsState {
  products: Product[];
  categories: Category[];
  shipping: ShippingSettings;
  loaded: boolean;
  loading: boolean;
  fetchProducts: () => Promise<void>;
  fetchCategories: () => Promise<void>;
  fetchShippingSettings: () => Promise<void>;
  startPolling: () => () => void;
}

const API_ROOT = () => (import.meta.env.VITE_API_URL || 'http://localhost:3001');
const PRODUCTS_API = () => API_ROOT() + '/api/products';
const CATEGORIES_API = () => API_ROOT() + '/api/categories';
const SETTINGS_API = () => API_ROOT() + '/api/settings';
const POLL_INTERVAL_MS = 8000;

export const useProductsStore = create<ProductsState>((set, get) => ({
  // İlk render'da statik veriyle başlıyoruz (site hiç boş kalmasın diye);
  // backend'den veri gelir gelmez üzerine yazılıyor.
  products: staticProducts,
  categories: staticCategories,
  shipping: { shippingCost: 129, freeShippingMin: 1000 },
  loaded: false,
  loading: false,

  fetchProducts: async () => {
    if (get().loading) return;
    set({ loading: true });
    try {
      const response = await fetch(`${PRODUCTS_API()}/list.php`);
      if (!response.ok) throw new Error('Ürünler alınamadı');
      const data = await response.json();
      if (data.success && Array.isArray(data.products) && data.products.length > 0) {
        set({ products: data.products, loaded: true, loading: false });
      } else {
        set({ loading: false });
      }
    } catch (error) {
      // Backend henüz kurulmadıysa (örn. products.sql import edilmediyse) veya
      // erişilemiyorsa, sitenin statik veriyle çalışmaya devam etmesi için
      // burada sessizce vazgeçiyoruz.
      console.error('Ürünler backend\'den alınamadı, statik veri kullanılıyor:', error);
      set({ loading: false });
    }
  },

  fetchCategories: async () => {
    try {
      const response = await fetch(`${CATEGORIES_API()}/list.php`);
      if (!response.ok) throw new Error('Kategoriler alınamadı');
      const data = await response.json();
      if (data.success && Array.isArray(data.categories) && data.categories.length > 0) {
        set({ categories: data.categories });
      }
    } catch (error) {
      console.error('Kategoriler backend\'den alınamadı, statik veri kullanılıyor:', error);
    }
  },

  fetchShippingSettings: async () => {
    try {
      const response = await fetch(`${SETTINGS_API()}/get.php`);
      if (!response.ok) throw new Error('Ayarlar alınamadı');
      const data = await response.json();
      if (data.success && data.settings) {
        set({
          shipping: {
            shippingCost: Number(data.settings.shippingCost) || 129,
            freeShippingMin: Number(data.settings.freeShippingMin) || 1000,
          },
        });
      }
    } catch (error) {
      console.error('Kargo ayarları backend\'den alınamadı, varsayılan kullanılıyor:', error);
    }
  },

  // Admin panelinde yapılan DEĞİŞİKLİKLERİN (fiyat, görsel, isim, stok,
  // kategori, kargo ayarları — hepsi) siteye anlık yansıması için düzenli
  // aralıklarla arka planda yeniden çekiyoruz.
  startPolling: () => {
    const interval = setInterval(() => {
      get().fetchProducts();
      get().fetchCategories();
      get().fetchShippingSettings();
    }, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  },
}));
